<template>
	<div class="">
		<div v-if="showLoginForm">

			<div class="text-center text-base font-medium sm:text-lg pb-4" v-if="newUser">
				<p>You have signed up successfully</p>
				<p class="text-sm">Please enter your login details</p>
			</div>

			<!-- title -->
			<div v-else>
				<h1 class="text-center text-base font-medium sm:text-lg pb-4">
					Sign in to your account
				</h1>
			</div>
			<ErrorNotification :errorMessage="formErrorMessage" class="mb-3" />
			<form class="space-y-4" @submit.prevent>
				<!-- email input -->
				<CustomInput id="emailInput" v-model="email" placeholder="Email" name="email" type="email"
					:error="errors.email" />
				<!-- password input -->
				<CustomInput id="passwordInput" v-model="password" placeholder="Password" name="password"
					type="password" :error="errors.password" />

				<!-- remember me checkbox -->
				<div class="flex items-center justify-between pb-2 px-3">
					<div class="flex items-center">
						<input v-model="rememberMe" id="remember-me" name="remember-me" type="checkbox" class="
							h-4
							w-4
							text-blue-600
							focus:ring-blue-500
							border-gray-300
							rounded
						" />
						<label for="remember-me" class="ml-2 block text-sm text-gray-900">
							Remember me
						</label>
					</div>

					<!-- forgot password link -->
					<router-link id="forgotPasswordButton" to="/auth/forgot-password"
						class="font-medium text-gray-700 underline text-sm">
						Forgot password
					</router-link>
				</div>

				<!-- sign in button -->
				<CustomButton id="signInButton" text="Sign in" :disabled="disableSubmit" @click="signIn"
					:loading="loading" color="blue-600" class="py-4 text-base" />

			</form>
		</div>

		<div v-if="MFACode">
			<div v-if="!firstTime">
			<h1 class="text-center text-base font-medium sm:text-lg pb-4">
				Keeping you secure
			</h1>
				<p class="text-base font-sm sm:text-sm pb-4 text-center">To finish signing in, please enter your authentication code
			</p>
			</div>
			<div v-else>
				<h1 class="text-center text-base font-medium sm:text-lg pb-4">
				MFA set-up completed
			</h1>
			<p class="text-base font-sm sm:text-sm pb-4 text-center">To finish signing in, please wait for the next authentication code and enter it into the input box below.
			</p>

			</div>

			<form class="space-y-4" @submit.prevent>
				<!-- email input -->
				<CustomInput id="emailInput" v-model="mfaToken" label="MFA code" placeholder="Enter code"
					name="MFA code" type="text" :error="errors.email" />
				<!-- password input -->

				<p class="text-sm text-red-600" v-if="tokenSame">Authentication codes are single use, please enter a different code
				</p>
				<p class="text-sm text-red-600" v-if="incorrectMFA">Authentication code is incorrect please try again</p>

				<!-- sign in button -->
				<CustomButton id="signInButton" text="Sign in" @click="verifyMFAToken"
					:disabled="mfaToken == '' || tokenSame" :loading="loading" color="blue-600"
					class="py-4 text-base" />


			</form>
		</div>

		<div v-if="MFASetup">
			<h1 class="text-center text-base font-medium sm:text-lg pb-4">
				Set-up multi-factor authentication
			</h1>
			<form class="space-y-4" @submit.prevent>
				<p class="mt-2 text-base font-sm sm:text-sm  text-center">Boogi uses Multi-Factor Authentication (MFA) to make your
					account more secure.
				</p>
				<div class="mx-auto">
					<div>
						<center>
							<div class="">
								<!-- <QRCodeVue3 :value="qrCodeValue" :width="180" :height="180" /> -->
								<qrcode-vue :value="qrCodeValue" :size="180" level="H" render-as="svg" />
								<p class="text-base mt-2 font-sm sm:text-xs pb-4">Manual code:
									{{ qrCodeValue.split("=")[1] }}</p>
							</div>
						</center>

					</div>
				</div>
				<p class="text-base font-sm sm:text-sm pb-4 text-center">To finish setting up your account. Please scan the QR code
					using your
					favourite authenticator app then enter the single use authentication code into the input field.</p>

				<!-- email input -->
				<CustomInput id="emailInput" v-model="mfaTokenCreation" label="MFA code" placeholder="Enter code"
					name="MFA code" type="text" :error="errors.email" />

				<p class="text-sm text-red-600" v-if="mfaSetupError">Authentication code is incorrect please try again</p>
				<!-- password input -->

				<!-- sign in button -->
				<CustomButton id="signInButton" text="Set-up MFA" @click="setupMFA()" :loading="loading" color="blue-600"
					class="py-4 text-base" />

			</form>
		</div>

	</div>
</template>

<script>
import CustomInput from "@/components/inputs/CustomInput.vue";
import CustomButton from "@/components/inputs/CustomButton.vue";
import ErrorNotification from '@/components/inputs/ErrorNotification.vue'
import QrcodeVue from 'qrcode.vue'


export default {
	name: "SignIn",
	components: {
		CustomInput,
		CustomButton,
		ErrorNotification,
		QrcodeVue
	},
	props: {
		backdoorKey: {
			type: String
		}
	},
	data() {
		return {

			showLoginForm: true,
			MFASetup: false,
			MFACode: false,
			incorrectMFA: false,

			session: undefined,
			mfaToken: "",
			mfaTokenCreation: undefined,
			firstTime: false,
			mfaSetupError:false,
			qrCodeValue: undefined,
			newUser: this.$route.query.type == 'newUser',




			email: "",
			password: "",
			rememberMe: JSON.parse(localStorage.getItem('rememberMe')) || true,
			loading: false,
			errorMessage: undefined,
			formErrorMessage: "",
			errors: {
				type: Object,
				default: function () {
					return {
						email: "",
						password: ""
					}
				}
			}
		}
	},
	created() {

	},
	methods: {
		closeModal() {
			this.showErrorModal = false;
		},

		async getUser() {
			try {
				const token = localStorage.getItem('token')
				this.loading = true

				const response = await this.$apiFetch(`https://${process.env.VUE_APP_DEFAULT_API}.boogi.io/private/api/client/user`, {
					method: "GET",
					headers: {
						"Content-Type": "application/json",
						"Authorization": `${token}`,
					},
				});

				if (response.ok) {
					var object = await response.json()
					var publisher = object.publisher
					localStorage.setItem("firstName", object.publisherUser.firstName)
					localStorage.setItem("lastName", object.publisherUser.lastName)
					localStorage.setItem("publisher", publisher.companyName)
					localStorage.setItem("publisherId", publisher.id)
					
					localStorage.setItem("publisherStatus", publisher.publisherStatus)
					localStorage.setItem("sandbox", publisher.sandboxOnly)
					localStorage.setItem("sendContentNotifications", object.publisherUser.sendContentNotifications)


					if (publisher.sandboxOnly) {
						localStorage.setItem("apiType", process.env.VUE_APP_SANDBOX_API)

					} else {
						localStorage.setItem("apiType", process.env.VUE_APP_DEFAULT_API)

					}

					this.$router.push("/")

				} else {
					this.formErrorMessage = "Incorrect email or password"

				}

			} catch (error) {
				this.formErrorMessage = "Incorrect email or password"
				return;
			}

		},

		async setupMFA() {
			try {

				var body = {
					mfaToken: this.mfaTokenCreation,
					email: this.email,
					password: this.password,
					session: this.session
				}

				const response = await this.$apiFetch(`https://${process.env.VUE_APP_DEFAULT_API}.boogi.io/private/api/client/auth/create-mfa-connection`, {
					method: "POST",
					body: JSON.stringify(body),
					headers: {
						"Content-Type": "application/json",
					},
				});

				if (response.ok) {
					var object = await response.json()
					this.session = object.session

					if (object.status == "MFA_REQUIRED") {
						this.showLoginForm = false
						this.MFASetup = false
						this.MFACode = true
						this.firstTime = true
					}
					if (object.status == "MFA_SETUP") {
						this.qrCodeValue = object.qrcodeData
						this.showLoginForm = false
						this.MFACode = false
						this.MFASetup = true
					}



				}
				else {
					this.mfaTokenCreation = undefined
					this.mfaSetupError = true

				}

			} catch (error) {
				this.mfaTokenCreation = undefined
				return;
			}

		},


		async verifyMFAToken() {
			try {

				var body = {
					mfaToken: this.mfaToken,
					email: this.email,
					session: this.session
				}

				const response = await this.$apiFetch(`https://${process.env.VUE_APP_DEFAULT_API}.boogi.io/private/api/client/auth/verify-mfa`, {
					method: "POST",
					body: JSON.stringify(body),
					headers: {
						"Content-Type": "application/json",
					},
				});

				if (response.ok) {
					var object = await response.json()
					var token = "Bearer " + object.idToken
					localStorage.setItem('token', token)
					this.getUser()
				}
				else {
					this.incorrectMFA = true
				}

			} catch (error) {
				this.incorrectMFA = true
				return;
			}

		},

		async signIn() {
			try {

				var body = {
					email: this.email,
					password: this.password
				}

				const response = await this.$apiFetch(`https://${process.env.VUE_APP_DEFAULT_API}.boogi.io/private/api/client/auth/login`, {
					method: "POST",
					body: JSON.stringify(body),
					headers: {
						"Content-Type": "application/json",
					},
				});

				if (response.ok) {
					var object = await response.json()
					this.session = object.session

					if (object.status == "MFA_REQUIRED") {
						this.showLoginForm = false
						this.MFASetup = false

						this.MFACode = true
					}
					if (object.status == "MFA_SETUP") {
						this.qrCodeValue = object.qrcodeData
						this.showLoginForm = false
						this.MFACode = false
						this.MFASetup = true
					}


					this.session = object.session
				}
				else {
					this.formErrorMessage = "Incorrect email or password"
				}

			} catch (error) {
				this.formErrorMessage = "Incorrect email or password"
				return;
			}


		}
	},
	computed: {
		disableSubmit: function () {
			if (this.email.length < 1) return true
			if (this.password.length < 1) return true
			if (this.tokenSame) return true
			return false
		},
		signinData: function () {
			return {
				email: this.email,
				password: this.password
			}
		},
		tokenSame: function () {
			return this.mfaToken == this.mfaTokenCreation
		}
	},
	mounted() {
		document.title = "Sign in";
	},
	watch: {
		email: function (value) {
			this.email = value.toLowerCase();
			this.formErrorMessage = ""
		},
		password: function () {
			this.formErrorMessage = ""
		},
		rememberMe: function () {
			localStorage.setItem('rememberMe', this.rememberMe)
		}
	}
}
</script>

<style></style>
